import React, {useContext, useEffect, useState} from "react";
import NewAddon from "../../components/authentication/newAddon";
import SetItemsContext from "../../tools/contexts/authenticatonService/SetItemsContext";
import Api from "../../tools/service";
import SelectServices from "../../components/authentication/SelectServices";
import Guid from "../../components/Guid";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";
import {authenticationPriceCalculator} from "../../tools/helpers";
import LoadingScreen from "../LoadingScreen";

const defaultOptions = {
    "IAuth": "ia_pre_msg",
    "BusinessLicenseInquiry": "BusinessLicenseInquiry_pre_msg",
    "ExpertInquiry": "ExpertInquiry_pre_msg",
    "LawyerInquiry": "LawyerInquiry_pre_msg",
    "PoliceClearance": "PoliceClearance_pre_msg"
};


const NewSelectItems = () => {
    const serviceContext = useContext(AuthenticationServiceContext)
    const [getItemsData, setGetItemsData] = useState(null);
    const [step, setStep] = useState(0);
    const [selectedType, setSelectedType] = useState("post")
    const [requiredServices, setRequiredServices] = useState([])
    const [optionalServices, setOptionalServices] = useState([])
    const [selectedServices, setSelectedServices] = useState([])
    const [showAddonCard, setShowAddonCard] = useState(false);
    const [addonIsActive, setAddonIsActive] = useState(false);
    const [showGuide, setShowGuide] = useState(false);
    const [guideSlides, setGuideSlides] = useState([]);
    const [options, setOptions] = useState(null);
    const [price, setPrice] = useState(null);
    const [defaultService, setDefaultService] = useState(null);
    const [serviceDisabled, setServiceDisabled] = useState(false);
    const [loading, setLoading] = useState({
        isActive: true,
        message: 'در حال  دریافت اطلاعات'
    });
    const handleGetItems = () => {
        setLoading({
            isActive: true,
            message: 'در حال  دریافت اطلاعات'
        })
        Api.get(REQUEST_URLS.AUTHENTICATION.GET_ITEMS, {
            params: {
                pid: serviceContext.pid,
            },
            headers: {
                "Authorization": `Bearer ${serviceContext.token}`
            }
        }).then(response => {
            const {data, status, message, hasError} = response;
            if (hasError) {
                serviceContext.handleError({
                    status, message, data, callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            onConfirm: () => {

                            },
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                handleGetItems();
                                Reoverlay.hideModal();

                            }
                        })
                    }
                })
            } else {
                let disabled = false;
                data.items.forEach((item, index) => {
                    if (item.disabled) {
                        if (data.default_service === item.service_type) {
                            disabled = true;
                            setServiceDisabled(true)
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: 'کاربر گرامی در حال حاضر سرویس مورد نظر با اختلال همراه است. لطفا دقایقی بعد مجددا تلاش نمایید.'
                            })
                        }
                    }
                })
                if (!disabled) {
                    setGetItemsData(data)
                }
            }
        }).catch(e => {

        }).finally(() => {
            setLoading({
                isActive: false,
                message: 'در حال دریافت اطلاعات'
            })

        })
    }
    const handleIsUserAddonActive = (data) => {

        switch (data.default_service) {
            case "PoliceClearance": {
                setShowAddonCard(true);
                setStep(1)
                break
            }
            case "IAuth": {
                setShowAddonCard(true);
                setStep(1)
                break
            }
            case "BusinessLicenseInquiry": {
                setShowAddonCard(true);
                setStep(1)
                break
            }
            default : {
                setShowAddonCard(true)
                setStep(1)
            }
        }
    }
    useEffect(() => {
        if (selectedServices && selectedType && selectedServices.length > 0 && getItemsData) {
            const price = authenticationPriceCalculator(selectedType, defaultService, getItemsData.items, selectedServices, getItemsData.discount);
            setPrice(price)
        }
    }, [selectedServices, selectedType])
    useEffect(() => {
        if (getItemsData) {
            const required = getItemsData.items.filter(service => !service.is_optional && !service.disabled);
            const optional = getItemsData.items.filter(service => service.is_optional && !service.disabled);
            const dService = getItemsData.items.filter((item) => item.service_type === getItemsData.default_service);
            if (dService && dService.length > 0) {
                setDefaultService(dService[0])
            }
            setOptionalServices([...optional])
            setRequiredServices([...required])
            setSelectedServices([...required])

            if (getItemsData.is_user_add_on_active || getItemsData.is_police_user_add_on_active || getItemsData.is_business_add_on_active) {
                setAddonIsActive(true)
            } else {
                setAddonIsActive(false)
            }
            handleIsUserAddonActive(getItemsData)
        }
    }, [getItemsData]);
    useEffect(() => {
        handleGetOptions();
    }, []);

    const handleConfirm = (hasLadder=false) => {
        setLoading({
            isActive: true,
            message: 'در حال ارسال اطلاعات'
        })
        const selectedData = selectedServices.map((item) => ({
            service_type: item.service_type,
            selected_sub_services: item.sub_services.filter(sub_service => !sub_service.is_optional).map(sub_services => sub_services.name),
        }));
        const data = {
            pid: serviceContext.pid,
            selected_items: selectedData,
            has_nardeban:hasLadder,
            is_user_add_on: selectedType === "add_on" && getItemsData.is_user_add_on_active,
            is_police_user_add_on: selectedType === "add_on" && getItemsData.is_police_user_add_on_active,
            is_business_add_on: selectedType === "add_on" && getItemsData.is_business_add_on_active,
        }

        Api.put(REQUEST_URLS.AUTHENTICATION.SET_ITEMS, data, {
            headers: {
                "Authorization": `Bearer ${serviceContext.token}`
            }
        }).then(response => {
            const {hasError, status, message, data} = response;
            if (hasError) {
                serviceContext.handleError({
                    status: status,
                    data: data,
                    message: message,
                    hasError: hasError,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            onConfirm: () => {

                            },
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onCancel: () => {

                                Reoverlay.hideModal();

                            }
                        })
                    }
                });
                setLoading({
                    isActive: false,
                    message: 'در حال ارسال اطلاعات'
                })
            } else {
                serviceContext.handleGetProcess(serviceContext.pid)
            }
        }).catch(e => {
            console.log(e);
            setLoading({
                isActive: false,
                message: 'در حال ارسال اطلاعات'
            })
        }).finally(() => {

        })

    }
    const handleChangeSelectedServices = (newSelectedServices) => {
        setSelectedServices([...newSelectedServices])
    }
    const handleGetOptions = () => {
        setLoading({
            isActive: true,
            message: 'در حال ارسال اطلاعات'
        })
        if (options) {
            handleGetItems();
        } else {
            setLoading({
                isActive: true,
                message: 'در حال دریافت اطلاعات'
            })
            Api.get('/api/v1/options').then((response) => {
                /*setLoading(false);*/
                const {data, status, hasError, message} = response;
                if (!hasError) {

                    if (data.length > 0) {
                        setOptions(data);
                        handleGetItems();
                    }

                } else {
                    serviceContext.handleError({
                        status,
                        message,
                        data,
                        callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای سرویس',
                                onConfirm: () => {

                                },
                                showConfirmButton: false,
                                showCancelButton: true,
                                cancelButtonText: 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                onCancel: () => {

                                    Reoverlay.hideModal();

                                }
                            })
                        }
                    })
                }
            }).catch((e) => {
                /*setLoading(false)*/

            })
        }
    }
    const handleStep = (newStep) => {
        setStep(newStep)
    }
    const handleSelectedType = (newType) => {
        setSelectedType(newType)
    }
    const handleShowOption = (service_type) => {

        const key = defaultOptions[service_type];

        if (options && options.length > 0) {
            options.forEach((item, index) => {

                if (item.key === key) {
                    setGuideSlides(JSON.parse(item.value));
                    setShowGuide(true)

                }

            })
        }

    }
    return <>
        <SetItemsContext.Provider value={
            {
                price,
                defaultService,
                step,
                selectedServices,
                requiredServices,
                optionalServices,
                data: getItemsData,
                addonIsActive,
                showAddon: showAddonCard,
                selectedType,
                options,
                handleStep,
                handleSelectedType,
                handleShowOption,
                handleChangeSelectedServices,
                handleConfirm,
                handleGetItems,
            }
        }>
            {loading && loading.isActive && <LoadingScreen text={loading.message}/>}
            {!loading.isActive && showGuide &&
                <Guid hasBack={true} onBack={() => setShowGuide(false)} imageClass="w-7/12 md:w-7/12 lg:w-3/12"
                      theme={"green"} slides={guideSlides} closeGuid={() => setShowGuide(false)}/>}
            {!loading.isActive && !serviceDisabled && step === 1 && showAddonCard && <NewAddon/>}
            {!loading.isActive && !serviceDisabled && step === 2 && <SelectServices/>}
        </SetItemsContext.Provider>
    </>


}
export default NewSelectItems;